module.exports = __webpack_public_path__ + "static/media/anishapic.a2d56fe0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/shifting/anishapic.jpeg
// module id = 125
// module chunks = 0